export const data =
{
    scene: 'scene_02_pistopaikka',
    kysymysteksti_1: 'Pentti haluaa, että ikävin toimenpide eli insuliinin pistäminen hoidetaan nopeasti alta pois. Ohjaajasi haluaa, että näytät ensin mikä olisi sopiva pistokohta - näytä se klikkaamalla kuvasta ',
    kysymysteksti_2: 'Teija auttaa sinua pistokohdan valinnassa. Klikkaa nyt kuvasta sopiva pistokohta ',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: '',
            valinta: '',
            ohjaajan_palaute: '',
            koontiteksti: '',
            pisteet: 1,
            arviointitiedosto: 'scene_02_pistopaikka_ok',
            kuva: '',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 1,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }

            ]
        },
        {
            id: 1,
            teksti: 'Ohjaajan avustuksella löydetty oikea pistokohta',
            valinta: 'scene_02 pistopaikka ohjaajan avulla',
            ohjaajan_palaute: '',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_02_pistopaikka_ei_ok',
            kuva: '',
            harjoiteltava: ["pistämistä"],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 1,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }

            ]
        }

    ]
};



